// Generated from concrete Settings page.tsx paths; checked by DOC-48 tests.
export const SETTINGS_DESTINATION_PATTERNS: readonly string[] = [
  '/settings',
  '/settings/approvals',
  '/settings/assessments',
  '/settings/billing',
  '/settings/cert-allowance-registry',
  '/settings/cm-task-types',
  '/settings/comfort-coordination',
  '/settings/compliance',
  '/settings/data-management',
  '/settings/document-templates',
  '/settings/facilities',
  '/settings/facility-config',
  '/settings/feature-flags',
  '/settings/funding-authorisations',
  '/settings/holidays',
  '/settings/import',
  '/settings/integrations',
  '/settings/integrations/dhda',
  '/settings/integrations/hi',
  '/settings/integrations/services-australia',
  '/settings/integrations/services-australia/conformance',
  '/settings/integrations/services-australia/event-reconciliation',
  '/settings/integrations/services-australia/mapping',
  '/settings/integrations/xero',
  '/settings/integrations/xero/backfill',
  '/settings/integrations/xero/wizard/[[...step]]',
  '/settings/leave-policies',
  '/settings/modules',
  '/settings/notification-audit',
  '/settings/notification-preferences',
  '/settings/notification-routing',
  '/settings/notification-routing/wizard',
  '/settings/notifications',
  '/settings/notifications/log',
  '/settings/onboarding',
  '/settings/onboarding-packs',
  '/settings/onboarding/client-packs',
  '/settings/onboarding/consents',
  '/settings/onboarding/dms-cutover',
  '/settings/onboarding/induction-policies',
  '/settings/onboarding/readiness',
  '/settings/onboarding/screening',
  '/settings/onboarding/worker/base',
  '/settings/organisation',
  '/settings/payroll',
  '/settings/payroll/activation',
  '/settings/payroll/aba-sender',
  '/settings/payroll/eba',
  '/settings/payroll/eba/[ebaId]',
  '/settings/payroll/eba/[ebaId]/activate',
  '/settings/payroll/eba/[ebaId]/certification',
  '/settings/payroll/eba/[ebaId]/dry-run',
  '/settings/payroll/eba/[ebaId]/export',
  '/settings/payroll/eba/[ebaId]/manual-facts',
  '/settings/payroll/eba/[ebaId]/rate-lines',
  '/settings/payroll/eba/[ebaId]/rate-schedule',
  '/settings/payroll/eba/[ebaId]/rules',
  '/settings/payroll/eba/[ebaId]/scope',
  '/settings/payroll/eba/[ebaId]/staff',
  '/settings/payroll/generic-csv-earnings',
  '/settings/payroll/pay-roles',
  '/settings/payroll/pay-roles/prior-hours/[batchId]',
  '/settings/payroll/profile',
  '/settings/payroll/provider-responsibilities',
  '/settings/payroll/worked-time-rules',
  '/settings/people',
  '/settings/people/assignment-requirements',
  '/settings/portal',
  '/settings/registration-providers',
  '/settings/retention',
  '/settings/roster',
  '/settings/security',
  '/settings/service-execution',
  '/settings/signature-templates',
  '/settings/system',
  '/settings/users',
  '/settings/webhooks',
  '/settings/webhooks/[id]/mapping',
  '/settings/webhooks/docs',
  '/settings/workflows',
  '/settings/workflows/[id]',
  '/settings/workflows/closeout',
];
